<template>
    <div class="editable_list_item" :class="{ disabled_item: $props.disabled===true }">
        <div class="item_title">Próximas datas</div>
        <add-div ref='add' v-model="isAdding" @add="onCurrentAdd" @edit="onCurrentEdit"></add-div>
        <div v-if="!isAdding">
            <table>
                <thead>
                    <tr>
                        <th>Data de Início</th>
                        <th>Complemento</th>
                        <th>Horário</th>
                        <th>Localização</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in items" :key="index" class="item">
                        <td>
                            <div v-if="item.type == 'single' || item.type == 'interval'">{{item.data.date}}</div>
                            <div v-else>{{item.data[0].date}}</div>
                        </td>
                        <td>
                            <div v-if="item.type=='single'">dia único</div>
                            <div v-if="item.type=='interval'">
                                até o dia {{item.data.dateEnd}}
                            </div>
                            <div v-if="item.type=='multiple'">
                                lista de todos os dias:
                                <span v-for="(current, i) in item.data" :key="i">
                                    {{current.date.substring(0,5)}},
                                </span>
                            </div>
                        </td>
                        <td>
                            <div v-if="item.type == 'single' || item.type == 'interval'">{{item.data.time}} às {{item.data.timeEnd}}</div>
                            <div v-else>{{item.data[0].time}} às {{item.data[0].timeEnd}} ( * horários podem variar )</div>
                        </td>
                        <td>
                            {{item.location}}
                        </td>
                        <td class="editCol">
                            <button class="flake-btn" @click="edit(index)" v-if="$props.disabled!==true"><i class="material-icons">edit</i></button>
                            <button class="flake-btn" @click="remove(index)" v-if="$props.disabled!==true"><i class="material-icons">delete</i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <button class="fluke-btn" @click="add" v-if="$props.disabled!==true">Adicionar</button>
        </div>
        <global-popup ref="remove" title="Remover">Deseja remover o a data?</global-popup>
    </div>
</template>

<script>
import UD_Add from './UpcomingDates_Add';

export default {
    props: [ 'disabled' ],
    components: {
        'add-div': UD_Add
    },
    data() {
        return {
            dates: [],
            /**
             * all: Type, Begin
             * single : EventTime
             * interval : End, EventTime
             * multiple : Days { Date, EventTime }, SameTime
             */
            current: {},
            isAdding: false,
            editingItem: false,
        }
    },
    computed: {
        items: {
            get() {
                if( this.$store.state.course.data.dates == null ) return []
                return this.$store.state.course.data.dates.map( el => {
                    if( typeof el.location == 'undefined' )
                        el.location = this.$store.state.course.data.location;
                    return el;
                });
            },
            set(value) {
                this.$store.commit('set_course_dates', value);
            }
        }
    },
    methods: {
        add() {
            this.isAdding = true;
        },
        edit( index ) {
            this.$refs.add.edit( this.items.find( (el, idx) => idx == index ) );
            this.editingItem = index;
        },
        remove(index){
            this.$refs.remove
                .confirm()
                .then(()=>{
                    var lista = this.items.filter( (el, idx) => idx != index );
                    this.items = lista;
                });
        },
        setAsLink( value ) {
            const matches = value.match(/^http:\/\/|^https:\/\//);
            if( matches && matches.length ) return value;
            return 'http://' + value;
        },
        onCurrentAdd( value )
        {
            value.link = this.setAsLink( value.link );
            this.current = value;

            var lista = this.items;
            lista.push(this.current);
            this.items = lista;
            this.current = [];

            this.reorder();
        },
        onCurrentEdit( value )
        {
            value.link = this.setAsLink( value.link );

            var lista = this.items.map( (el, index) => {
                if( this.editingItem == index ) {
                    return value;
                } else {
                    return el;
                }
            });
            this.items = lista;
            this.current = [];

            this.reorder();
        },
        reorder() {
            this.items = this.items.sort( ( el, elem ) => {
                const keyEl = this.getOrderKey( el );
                const keyElem = this.getOrderKey( elem );

                if( keyEl < keyElem ) return -1;
                if( keyEl > keyElem ) return 1;
                return 0;
            });
        },
        getOrderKey( el ){
            var key;
            if( el.type == 'single' || el.type == 'interval' ) {
                key = el.data.date;
            } else {
                key = el.data[0].date;
            }
            return key.split('/').reverse().join('');
        }
    }

}
</script>